<template>
  <div class="container">
    <form @submit.prevent="submitForm">
      <div class="row">
        <div class="col custom-pricing-options">
          <div class="form-check">
            <input
              v-model="form.product"
              class="form-check-input me-2 custom-checkbox-medium"
              type="radio"
              name="product_monthly"
              id="product_monthly"
              value="monthly"
              rules="required"
            />
            <label class="form-check-label" for="product_monthly"> Monthly Subscription </label>
          </div>
          <div class="form-check ms-3">
            <input
              v-model="form.product"
              class="form-check-input me-2 custom-checkbox-medium"
              type="radio"
              name="product_monthly_autofill"
              id="product_monthly_autofill"
              value="monthly_autofill"
              rules="required"
            />
            <label class="form-check-label" for="product_monthly_autofill"> Monthly Subscription with Auto-Fill</label>
          </div>
          <div class="form-check ms-3">
            <input
              v-model="form.product"
              class="form-check-input me-2 custom-checkbox-medium"
              type="radio"
              name="product_annual"
              id="product_annual"
              value="annual"
              rules="required"
            />
            <label class="form-check-label" for="product_annual"> Annual Subscription </label>
          </div>
          <div class="form-check ms-3">
            <input
              v-model="form.product"
              class="form-check-input me-2 custom-checkbox-medium"
              type="radio"
              name="product_annual_autofill"
              id="product_annual_autofill"
              value="annual_autofill"
              rules="required"
            />
            <label class="form-check-label" for="product_annual_autofill"> Annual Subscription with Auto-Fill </label>
          </div>
          <a v-if="showReview" href="#" class="custom-view-options" @click="showOptions">review options</a>
        </div>
      </div>
      <div class="row custom-card-row">
        <div class="col">
          <div class="input-group">
            <span class="input-group-text">Credit Card:</span>
            <div id="card-element" ref="cardElement" class="custom-credit-card"></div>
          </div>
          <span v-show="isCardValid" :class="{ 'card-error': isCardValid }">{{ errorCreditCard }}</span>
          <img src="~@/assets/powered-by-stripe.png" alt="powered by Stripe" class="custom-stripe" />
        </div>
        <div class="col"></div>
      </div>
      <div v-if="testMode">
        <p>In Test Mode - use one of the following credit card scenarios:</p>
        <ul class="custom-list">
          <li>4242 4242 4242 4242: Succeeds and immediately creates an active subscription.</li>
          <li>
            4000 0025 0000 3155: Requires authentication. this will trigger a dialog asking for the user to authenticate. Once confirmation is
            successful, the subscription will become active.
          </li>
          <li>4000 0082 6000 3178: Always fails with a decline code of 'insufficient funds'.</li>
        </ul>
      </div>
      <div class="row">
        <div class="col">
          <p>Note: be sure not to double-click the 'Purchase' button as this may cause multiple purchase registrations.</p>
        </div>
      </div>
    </form>
  </div>
  <DialogOptions v-model="actionOptions" @closing="closeModal" @firmSaved="firmSaved" @saved="savedLocation" />
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { onboardStore } from '@/stores/onboard'
import DialogOptions from '@/components/onboard/forms/DialogOptions.vue'
export default {
  name: 'OnboardPurchase',
  components: {
    DialogOptions
  },
  props: {
    showReview: {
      type: Boolean,
      default: true
    },
    editMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        type: 'purchase',
        valid: false,
        id: null,
        firm: null,
        product: 'monthly',
        paymentMethod: null,
        token: '',
        coupon: ''
      },
      actionOptions: false,
      show: true,
      stripe: undefined,
      creditCard: null,
      errorCreditCard: '',
      isOkay: true
    }
  },
  mounted() {
    this.actionOptions = false
    let $this = this
    setTimeout(() => {
      $this.initStripe()
    }, 300)
  },
  watch: {
    testMode() {
      this.initStripe()
    },
    onboard() {
      if (this.onboard !== undefined && this.onboard !== null) {
        if (this.onboard.purchase !== undefined && this.onboard.purchase !== null) {
          if (this.onboard.purchase.product !== undefined && this.onboard.purchase.product !== null) {
            this.form.product = this.onboard.purchase.product
          }
        }
      }
    }
  },
  emits: ['save'],
  computed: {
    ...mapState(onboardStore, ['products', 'onboard', 'testMode']),
    isShow: {
      get() {
        let _show = true
        if (this.onboard !== undefined && this.onboard !== null) {
          if (this.onboard.purchase !== undefined && this.onboard.purchase !== null) {
            if (this.onboard.purchase.paymentMethod !== undefined && this.onboard.purchase.paymentMethod !== null) {
              _show = false
            }
          }
        }
        return _show
      }
    },
    isCardValid() {
      return this.errorCreditCard !== ''
    }
  },
  methods: {
    ...mapActions(onboardStore, ['toggleDisable', 'resetPaymentMethod', 'getCountryCode', 'getStateProvinceAbbr']),
    makeToast(variant = null, content) {
      this.$emit('makeToast', {
        title: variant === 'success' ? 'Success' : 'Error',
        variant: variant,
        content: content,
        source: 'purchase'
      })
    },
    showOptions() {
      this.actionOptions = true
    },
    closeModal() {
      this.actionOptions = false
    },
    initStripe() {
      let $this = this
      // styling for the card
      let style = {
        base: {
          color: '#212529',
          fontSize: '1.1em',
          fontSmoothing: 'antialiased',
          '::placeholder': {
            color: '#737C89'
          }
        },
        invalid: {
          color: '#e5424d',
          ':focus': {
            color: '#212529'
          }
        }
      }
      // init Stripe
      var stripeKey = ''
      if (this.testMode) {
        stripeKey = window.config ? window.config.teststripeKey : ''
      } else {
        // TODO: Add production key
        stripeKey = window.config ? window.config.teststripeKey : ''
      }
      console.log('Init Stripe', { testmode: this.testMode, key: stripeKey })
      try {
        this.stripe = window.Stripe(stripeKey)
        let elements = this.stripe.elements()
        // init card
        this.creditCard = elements.create('card', { style: style })
        // mount card
        this.creditCard.mount('#card-element')
        // event focus ring
        this.creditCard.on('focus', function () {
          $this.$refs.cardElement.classList.add('focused')
        })
        this.creditCard.on('blur', function () {
          $this.$refs.cardElement.classList.remove('focused')
        })
        // change listener event
        this.creditCard.addEventListener('change', (event) => {
          $this.errorCreditCard = ''
          if (event.error) {
            $this.errorCreditCard = event.error.message
          }
        })
      } catch (error) {
        console.log('Error Initializing Stripe', error)
      }
    },
    restartPaymentMethod() {
      this.form.valid = false
      this.resetPaymentMethod()
    },
    updateData(data) {
      // We've successfully saved the Firm information and made
      // the call to Stripe to create the customer.  Now,
      // we check for payment status with Stripe.
      let $this = this
      this.form.firm = data.firm
      // Purchase results
      console.log('Purchase results', data)
      // pull out latest invoice
      if (data.id.subscription !== undefined && data.id.subscription !== null) {
        const { latest_invoice } = data.id.subscription
        // from there, pull out payment intent
        const { payment_intent } = latest_invoice
        if (payment_intent) {
          // then, pull out status and client secret
          const { client_secret, status } = payment_intent
          console.log('Purchase Status', status)
          // if failed, confirm the payment with Stripe
          if (status === 'requires_action') {
            console.log('Requires Confirmation from Stripe', this.stripe)
            this.stripe.confirmCardPayment(client_secret).then(function (result) {
              if (result.error) {
                console.log('Credit Card Confirmation', result)
                $this.$emit('restartPurchase')
                // Display error message in your UI.
                // The card was declined (i.e. insufficient funds, card has expired, etc)
                $this.makeToast('danger', result.error.message)
              } else {
                // Show a success message to your customer
                $this.makeToast('success', 'Your account has been successfully established.')
              }
            })
          } else {
            // No additional information was needed
            // Show a success message to your customer
            $this.makeToast('success', 'Your account has been successfully established.')
          }
        }
      }
    },
    getLatestPurchase() {
      let purchase = null
      if (this.form.paymentMethod !== undefined && this.form.paymentMethod !== null) {
        if (this.form.paymentMethod.id !== '') {
          purchase = {
            product: this.form.product,
            coupon: this.form.coupon,
            paymentId: this.form.paymentMethod.id
          }
        }
      }
      return purchase
    },
    submitForm() {
      // this.save()
    },
    async save(override) {
      // This performs validation and calls Stripe for a payment method.
      // If successful, it'll respond with true and a followup call
      // is made to our API Services to save the firm information and
      // make a call to Stripe to create the customer and subscription.
      console.log('Purchasing...', {
        onboard: this.onboard,
        creditCard: this.creditCard
      })
      let $this = this
      let isValid = false
      this.allGood = false
      $this.form.valid = false
      if (this.errorCreditCard !== '') {
        $this.makeToast('danger', 'Invalid Credit Card Information')
      } else {
        console.log('Country Code', await this.getCountryCode(this.onboard.additional.country))
        console.log('State/Province', await this.getStateProvinceAbbr(this.onboard.additional.stateprovince))
        console.log('Validate Card...', {
          isShow: this.isShow,
          override: override
        })
        if (this.isShow || override) {
          this.toggleDisable(true)
          console.log('Validating Credit Card...')
          // Call Stripe for Payment Method
          isValid = await this.stripe
            .createPaymentMethod('card', this.creditCard, {
              billing_details: {
                address: {
                  city: this.onboard.additional.city,
                  country: await this.getCountryCode(this.onboard.additional.country),
                  line1: this.onboard.additional.addresslines,
                  line2: null,
                  postal_code: this.onboard.additional.postalcode,
                  state: await this.getStateProvinceAbbr(this.onboard.additional.stateprovince)
                },
                email: this.onboard.basic.email,
                name: `${this.onboard.basic.firstname} ${this.onboard.basic.lastname}`,
                phone: `${this.onboard.additional.phonecc}-${this.onboard.additional.phoneno}`
              }
            })
            .then((result) => {
              if (result.error) {
                console.log('Credit Card Error', result.error.message)
                $this.makeToast('danger', 'Credit Card Error')
                return false
              } else {
                $this.form.valid = true
                $this.form.paymentMethod = result.paymentMethod
                $this.toggleDisable(false)
                console.log('Purchase Form', $this.form)
                // Now, save the customer in our database (and on Stripe).
                $this.makeToast('success', 'Purchase Successful')
                $this.$emit('save', $this.form)
                return true
              }
            })
        }
      }
      $this.$emit('save', $this.form)
      if (!isValid) {
        this.toggleDisable(false)
      }
      return isValid
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-view-options {
  position: relative;
  margin-left: 60px;
}
.custom-pricing-options {
  font-size: 1em;
  font-weight: 500;
  display: inline-flex;
  border: 1px solid #970000;
  border-radius: 5px;
  padding: 15px;
  input {
    margin-right: 10px;
  }
}
.custom-card-row {
  margin-top: 25px;
  margin-bottom: 45px;
}
.custom-credit-card {
  border: 1px solid #b5b5b5;
  padding: 15px;
  width: 30em;
}
.card-error {
  display: block !important;
}
.custom-stripe {
  top: 10px;
  position: relative;
  width: 320px;
}
.custom-coupon {
  position: relative;
  top: 30px;
}
.custom-radio-label {
  margin-left: 10px;
}
.custom-list {
  margin-left: 40px;
}
</style>
